import React from 'react'

const ComingSoon = () => {
  return <h1 className='text-center mt-5'>Coming Soon</h1>
}

export default ComingSoon
